<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" default-expand-all :expand-on-click-node="false"></el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card ref="right_content" class="box-card" style="width: calc(100% - 290px);">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>编号：</label>
                        <el-input v-model="search_Obj.f_code" clearable @keyup.enter.native="doSearch" style="width: 130px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>名称：</label>
                        <el-input v-model="search_Obj.f_name" clearable @keyup.enter.native="doSearch" style="width: 130px"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>简称：</label>
                        <el-input v-model="search_Obj.f_alias" clearable @keyup.enter.native="doSearch" style="width: 130px"></el-input>
                    </div>
                    <div class="searchGroup" v-if="grade==4">
                        <label>灌浆类型：</label>
                        <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <div class="djBox" v-if="parents && parents.length>0" >
                        <i class="el-icon-caret-right"></i>
                        <el-breadcrumb separator-class="el-icon-arrow-right" style="display: inline-block;position: relative;top: 1px;margin-left: 4px">
                            <el-breadcrumb-item v-for="p in parents.slice().reverse()" :key="'p'+p.id"><span class="pppp" @click="toChild1(p.id)">{{p.name}}</span></el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="name" label="名称" sortable="custom">
                            <template slot-scope="scope">
                                <el-button v-if="grade<4" type="text" size="medium" @click="toChild(scope.$index, scope.row)" class="font1">{{scope.row.name}}</el-button>
                                <span v-else>{{scope.row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="code" label="编号" sortable="custom"></el-table-column>
                        <el-table-column prop="alias" label="简称" sortable="custom"></el-table-column>
                        <el-table-column prop="state" label="场景类型" sortable="custom" v-if="grade ==3">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.scene_type, "scene_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="state" label="灌浆类型" sortable="custom" v-if="grade ==4">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="order_index" label="顺序" sortable="custom" width="80"></el-table-column>
                        <el-table-column prop="pname" label="上级" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    :grade="grade"
                    :pid="pid"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    :grade="grade"
                    :pid="pid"
                    title="查看施工工程划分"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <Import
                    width="600px"
                    title="导入工程结构"
                    :isshow="importshow"
                    @on-close="closeImportDialog"
                    @on-imp-ok="impOk">
                </Import>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Import from "./import"
import listutil from "@/libs/listutil"
import { getListData, delData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'

export default {
    name: 'projectDivisionList',
    mixins: [listutil],
    components: {Edit, Info, Import, Btns, LabBtns},
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    data() {
        return {
            m_name: '工程划分',
            menu_id: 3100,
            list_url: "/api/admin/projectdivision/list",
            search_Obj: {
                f_code: '',
                f_name: '',
                f_alias: '',
                f_pid: '',
            },
            del_Obj:{
                url:'/api/admin/projectdivision/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type','scene_type'],
            parents: [],
            projectDivisionData: [],
            grade: 1,
            pid: 0,
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            importshow: false,
        };
    },
    methods: {
        add() {
            this.model_id = -1
            this.edit_title = "添加"
            this.editshow = true
        },
        edit(index, row) {
            this.edit_title = "编辑"
            this.model_id = row.id
            this.editshow = true
        },
        loadOtherData() {
            this.initTree()
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.parents = res.data.parents;
                    this.grade = res.data.grade
                    this.pid = res.data.f_pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        saveOk() {
            this.editshow = false
            this.getListData()
            this.initTree()
        },
        del(index, row) {
            this.$confirm('确定要删除该条数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del_Obj.data.ids = row.id
                delData(this.del_Obj).then(res => {
                    if (res.code == 1) {
                        this.$msgs(res.msg)
                        this.initTree()
                        this.getListData();
                    } else {
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => { })
        },
        delAll() {
            if (this.selectData.length <= 0) {
                this.$msg("请选择要删除的数据")
            } else {
                this.$confirm('确定要删除选中的数据吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = '';
                    for (let data of this.selectData) {
                        if (ids === '') {
                            ids = data.id + "";
                        } else {
                            ids += "," + data.id;
                        }
                    }
                    this.del_Obj.data.ids = ids
                    delData(this.del_Obj).then(res => {
                        if (res.code == 1) {
                            this.$msgs(res.msg)
                            this.initTree()
                            this.getListData();
                        } else {
                            this.$msg(res.msg)
                        }
                    })
                }).catch(() => { })
            }
        },
        toChild(index, row){
            this.search_Obj.f_pid = row.id
            this.pid = row.id
            this.current = 1
            this.search_Obj["pageNum"] = this.current;
            this.getData()
        },
        toChild1(pid){
            this.search_Obj.f_pid = pid
            this.pid = pid
            this.current = 1
            this.search_Obj["pageNum"] = this.current;
            this.getData()
        },
        clickPrjectDivision(data){
            this.search_Obj.f_pid = data.id
            this.current = 1
            this.getListData()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(1).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                }
            })
        },
        import(){
            this.importshow = true
        },
        impOk(){
            this.importshow = false
            this.initTree()
            this.getListData()
        },
        closeImportDialog(){
            this.importshow = false
        }
    }
};
</script>